import { createSelector } from "reselect";
// import _ from "lodash";
import moment from "moment";

const createSelectors = (parentReducer) => {
    return new (class {
        selectJP = (store) => {
            const reducer = store["MainReducer"];
            return reducer.jobpacks || false;
        };
        selectProfile = (store) => {
            const reducer = store["UserProfile_reducer"];
            return reducer.profile.profile || false;
        };

        selectJobPacks = createSelector(
            [this.selectJP, this.selectProfile],
            (jobPacks = false, { departments = false, areas = false }) => {
                if (jobPacks) {
                    let year = moment().format("YYYY");
                    let month = moment().format("MMM").toLowerCase();
                    let jobreference = [];
                    let jobs = jobPacks["active"] || [];
                    Object.values(jobs).map((f) => {
                        return Object.values(f).map((g) => {
                            return Object.values(g).map((h) => {
                                let monthReq;
                                if (month === "jan") {
                                    monthReq = "dec";
                                } else if (month === "feb") {
                                    monthReq = "jan";
                                } else if (month === "mar") {
                                    monthReq = "feb";
                                } else if (month === "apr") {
                                    monthReq = "mar";
                                } else if (month === "may") {
                                    monthReq = "apr";
                                } else if (month === "jun") {
                                    monthReq = "may";
                                } else if (month === "jul") {
                                    monthReq = "jun";
                                } else if (month === "aug") {
                                    monthReq = "jul";
                                } else if (month === "sep") {
                                    monthReq = "aug";
                                } else if (month === "oct") {
                                    monthReq = "sep";
                                } else if (month === "nov") {
                                    monthReq = "oct";
                                } else {
                                    monthReq = "nov";
                                }
                                let start = moment(
                                    h.profile.start_date,
                                    "DD-MM-YYYY"
                                );
                                let end = moment(
                                    h.profile.end_date,
                                    "DD-MM-YYYY"
                                );

                                let startmonth = moment().startOf("month");
                                let endmonth = moment().endOf("month");
                                let monthReq1 = moment()
                                    .year(year)
                                    .month(monthReq)
                                    .date(31);
                                let monthReq2 = moment()
                                    .year(year)
                                    .month(monthReq)
                                    .date(30);
                                if (
                                    (startmonth.isBetween(
                                        start,
                                        end,
                                        null,
                                        "[]"
                                    ) ||
                                        endmonth.isBetween(
                                            start,
                                            end,
                                            null,
                                            "[]"
                                        ) ||
                                        start.isBetween(
                                            startmonth,
                                            endmonth,
                                            null,
                                            "[]"
                                        ) ||
                                        end.isBetween(
                                            startmonth,
                                            endmonth,
                                            null,
                                            "[]"
                                        ) ||
                                        end.isBetween(
                                            monthReq1,
                                            endmonth,
                                            null,
                                            "[]"
                                        ) ||
                                        end.isBetween(
                                            monthReq2,
                                            endmonth,
                                            null,
                                            "[]"
                                        )) &&
                                    !h.profile.deleted
                                )
                                    jobreference.push(h.profile);
                                return null;
                            });
                        });
                    });
                    if (departments) {
                        jobreference = jobreference.filter((jp) => {
                            if (jp.departments && jp.departments !== "N/A") {
                                let flag = false;
                                departments.map((f) => {
                                    if (f === jp.departments) {
                                        flag = true;
                                    }
                                    return null;
                                });
                                return flag;
                            } else {
                                return true;
                            }
                        });
                    }

                    if (areas) {
                        jobreference = jobreference.filter((jp) => {
                            if (jp.areas && jp.areas !== "N/A") {
                                let flag = false;
                                areas.map((f) => {
                                    if (f === jp.areas) {
                                        flag = true;
                                    }
                                    return null;
                                });
                                return flag;
                            } else {
                                return true;
                            }
                        });
                    }
                    return jobreference;
                } else return false;
            }
        );
    })();
};

export default createSelectors;
